
import styled, { css } from 'styled-components';

const ButtonLayout = () => css`
    position: relative;
    display:flex;
    justify-content:center;
    height:100%;
    width:100%;
    text-align:center;

    background: ${({ christmasTheme }) => christmasTheme ? '#1D6FF7' : '#D8E6F0;'};
    border-radius: 8px;

    &:hover {
     background: ${({ christmasTheme }) => christmasTheme ? '#004d99' : '#cfdde8'};
    }
`;


export default styled.div([ButtonLayout]);